import { Component, OnInit, Input, ViewEncapsulation, SimpleChanges, OnChanges } from '@angular/core';
import { BaseComponent } from '../BaseComponent';
import { TranslateService } from '@ngx-translate/core';
import { AbstractControl } from '@angular/forms';
import { BaseOption } from 'src/app/model/BaseOption';
import { MatDatepicker } from '@angular/material/datepicker';
import { SessionService } from 'src/app/session-service.service';

@Component({
  selector: 'app-editor-input',
  templateUrl: './editor-input.html',
  styleUrls: ['./editor-input.css'],
  encapsulation: ViewEncapsulation.None
})
export class EditorInputComponent extends BaseComponent implements OnInit, OnChanges {
  @Input()
  optionsList: BaseOption[];

  @Input() value: any;

  @Input()
  isDisabled = false;


  @Input()
  startView = undefined;
  controlType = this.constructor.name;

  constructor(translateService: TranslateService, sessionService: SessionService) {
    super(translateService, sessionService);
  }

  ngOnInit(): void {
    if (this.value !== undefined) {
      this.control.setValue(this.value);
    }
    const validator = this.control.validator
      ? this.control.validator({} as AbstractControl)
      : {};
    this.isRequired = validator?.required;
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'optionsList': {
            if (this.optionsList) {
              if (this.optionsList.length === 1) {
                this.control.setValue(this.optionsList[0].value);
              }
            }
          }
        }
      }
    }
  }
}
